'use client';
import React from 'react';
import { HorizontalTabItemProps, HorizontalTabItemSize } from '../HorizontalTabItem/HorizontalTabItem';

interface HorizontalTabProps {
	children: React.ReactElement<HorizontalTabItemProps>[];
	activeIndex: number;
	onActiveIndexChange: (index: number) => void;
	size: HorizontalTabItemSize;
}

const SIZE_TO_PADDING_Y: Record<HorizontalTabItemSize, string> = {
	14: '0.375rem', // 6px
	16: '0.75rem',
	20: '0.75rem',
}

const HorizontalTab: React.FC<HorizontalTabProps> = ({ children, activeIndex, onActiveIndexChange, size }) => {
	return (
		<div
			style={{
				paddingTop: SIZE_TO_PADDING_Y[size],
				paddingBottom: SIZE_TO_PADDING_Y[size],
			}}
			className="flex flex-row gap-0 w-full"
		>
			{React.Children.map(children, (child, index) => {
				if (React.isValidElement<HorizontalTabItemProps>(child)) {
					return React.cloneElement(child, {
						...child.props,
						isActive: index === activeIndex,
						onClick: () => onActiveIndexChange(index),
					});
				}
				return child;
			})}
		</div>
	);
};

export default HorizontalTab;
